<template>
  <footer class="footer px-3 py-3">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-12 text-center">
        <div class="copyright text-center text-light">
          <a href="https://www.rhombuss.com">
             <img class="power-rhombuss" src="img/powered-by-rhombuss.png" alt="Powered by Rhombuss">
          </a>
         
          © {{year}} <a href="https://www.rhombuss.com" class="footer-link ml-1" target="_blank">All Right Reserved Rhombuss</a>
        </div>
      </div>

    </div>
  </footer>
</template>
<script>
export default {
  name: 'layoutFooter',
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>